export default function updateDictionaryRatings({de, en}) {
	if (de) {
		de['ratings.author'] = 'Autor';
		de['ratings.comment'] = 'Kommentar';
		de['ratings.captcha'] = 'Captcha';
		de['ratings.loading'] = 'lade...';
		de['ratings.captcha-prefix'] = 'Was ist das Ergebnis von';
		de['ratings.submit'] = 'Absenden';
		de['ratings.state.submitted'] = 'Gespeichert';
		de['ratings.state.submitting'] = 'Sende...';
		de['ratings.state.failed'] = 'Nachricht konnte noch nicht gesendet werden!';
		de['ratings.state.wrong-captcha'] = 'Falsches Captcha!';

		de['ratings.rating'] = 'Bewertung';
		de['ratings.heading'] = 'Bewertungen';
		de['ratings.subheading'] = 'Was über diesen Ort gesagt wird';
		de['ratings.showform'] = 'Eigene Bewertung abgeben';
		de['ratings.showall'] = 'Alle Bewertungen anzeigen';
		de['ratings.nothing'] = 'Bislang wurden noch keine Bewertungen abgegeben.';
		de['ratings.captcha-loading-error'] = 'Konnte das Captcha nicht laden';
		de['ratings.captcha-loading-retry'] = 'Neu versuchen';
	}

	if (en) {
		en['ratings.author'] = 'Author';
		en['ratings.comment'] = 'Comment';
		en['ratings.captcha'] = 'Captcha';
		en['ratings.loading'] = 'loading...';
		en['ratings.captcha-prefix'] = 'What\'s the result for';
		en['ratings.submit'] = 'Submit';
		en['ratings.state.submitted'] = 'Submitted';
		en['ratings.state.submitting'] = 'Submitting...';
		en['ratings.state.failed'] = 'Submitting failed';
		en['ratings.state.wrong-captcha'] = 'Wrong captcha';

		en['ratings.rating'] = 'Rating';
		en['ratings.heading'] = 'Ratings';
		en['ratings.subheading'] = 'Opinions about this place';
		en['ratings.showform'] = 'Enter own comment';
		en['ratings.showall'] = 'Show all ratings';
		en['ratings.nothing'] = 'So far, no reviews have been submitted yet.';
		en['ratings.captcha-loading-error'] = 'Unable to load the Captcha';
		en['ratings.captcha-loading-retry'] = 'Retry';
	}
}
